import React from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";

interface ClientOption {
  clientId?: string | null;
  clientName?: string | null;
}

interface ChangeClientModalProps {
  open: boolean;
  clients?: Array<ClientOption | null>;
  selectedClientId: string;
  onClose: () => void;
  onChangeSelectedClient: (event: SelectChangeEvent) => void;
  onApply: () => void;
}

export const ChangeClientModal: React.FC<ChangeClientModalProps> = ({
  open,
  clients,
  selectedClientId,
  onClose,
  onChangeSelectedClient,
  onApply,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Typography variant="h4" component="div">
          Swap Client
        </Typography>
      </DialogTitle>
      <DialogContent>
        <FormControl fullWidth sx={{ mt: 1 }}>
          <InputLabel id="calendar-client-select-label">Client</InputLabel>
          <Select
            labelId="calendar-client-select-label"
            id="calendar-client-select"
            value={selectedClientId}
            label="Client"
            onChange={onChangeSelectedClient}
          >
            {clients?.map((client) => (
              <MenuItem key={client?.clientId} value={client?.clientId || ""}>
                {client?.clientName || client?.clientId || "Unknown client"}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button fullWidth variant="outlined" onClick={onClose}>Cancel</Button>
        <Button fullWidth onClick={onApply} variant="contained" disabled={!selectedClientId}>
          Swap
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangeClientModal;
